import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

// The mutation re-selects project.quoteActivities so the Relay store learns the appended reply
// immediately — the thread renders without a refetch. quote.status is re-read too, though a reply
// never moves it, so the store can never drift from the server on this path.
const mutation = graphql`
	mutation sendQuoteReplyMutation($input: SendQuoteReplyInput!) {
		sendQuoteReply(input: $input) {
			quote {
				id
				status
			}
			project {
				id
				quoteActivities(first: 100) {
					edges {
						node {
							id
							eventType
							createdAt
							clientContactName
							clientContact {
								id
							}
							reason
							person {
								id
								fullName
							}
						}
					}
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError, uploadables) {
	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		uploadables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
